import axios from 'axios';

export const getters = {};

export const mutations = {};

export const actions = {
    index(vuexContext, { businessProfileId = '' } = {}) {
        const params = {};

        if (businessProfileId) {
            params.business_profile_id = businessProfileId;
        }

        return axios.$get('/v1/labels', { params });
    },

    store(vuexContext, data) {
        return axios.$post('/labels', data);
    }
};
